import { h, Fragment, ComponentChildren } from 'preact';
import Match from 'preact-router/match';
import { useRouter } from 'preact-router';
import { useStore } from 'src/hooks';
import { isPromoRoute } from 'src/common/utils';
import { PROMO } from 'src/common/constants';
import UserType from 'src/common/usertype';
import Header from 'src/components/layout/header';
import Footer from 'src/components/layout/footer';
import Sidebar from 'src/components/sidebar';
import * as styles from './styles.less';

interface LayoutProps {
    children: ComponentChildren;
}

const Layout = ({ children }: LayoutProps) => {
    const ctx = useStore();
    const router = useRouter()[0];
    const currentURL = router?.url;
    const isStandaloneLayout = ctx.layout.type.value === 'standalone';
    const isPromoRunning = ctx.promo.phaseCounter.value || ctx.promo.phaseEvent.value || ctx.promo.phaseGame.value || ctx.promo.phaseHistory.value;
    const promoType = ctx.promo.type.value;
    const isPromoPage = isPromoRoute(currentURL);
    const isPromo = isPromoRunning && isPromoPage;

    return (
        <div class={styles.container}>
            {!isStandaloneLayout && (
                <>
                    <Match path="/chathost/:?">
                        {({ matches }: { matches: boolean }) => {
                            return matches && <Sidebar sidebarType={UserType.CHATHOST} />;
                        }}
                    </Match>
                    <Match path="/studio/:?">
                        {({ matches }: { matches: boolean }) => {
                            return matches && <Sidebar sidebarType={UserType.STUDIO} />;
                        }}
                    </Match>
                </>
            )}
            <div class={`${styles.container__outer} ${isStandaloneLayout ? styles.container__outer_full : ''} ${isPromo && promoType ? styles[PROMO[promoType].layoutClass] : ''}`}>
                <main class={`${styles.container__inner} ${isPromo && promoType ? styles[PROMO[promoType].layoutClass] : ''}`}>
                    {isStandaloneLayout || isPromo ? null : <Header />}
                    {children}
                    {isStandaloneLayout ? null : <Footer />}
                </main>
            </div>
        </div>
    );
};

export default Layout;
